module.exports = __webpack_public_path__ + "img/milli-1.0e1d81b.webp";